import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function CalculatorSection() {
  const [income, setIncome] = useState(1500000);
  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIncome(parseInt(e.target.value, 10));
  };
  let score = 45;
  let compatibility = 'Baja';
  let compatibilityColor = 'text-red-600';
  let observation = 'Tu principal problema es la falta de aval.';
  if (income >= 3000000) {
    score = 92;
    compatibility = 'Alta';
    compatibilityColor = 'text-green-600';
    observation = 'Perfil muy sólido. Tienes ventaja sobre otros postulantes.';
  } else if (income >= 1500000) {
    score = 75;
    compatibility = 'Media';
    compatibilityColor = 'text-yellow-600';
    observation = 'Buen perfil, pero podrías mejorar agregando un codeudor.';
  }
  return <section className="py-16 px-6 bg-white" data-id="element-6">
      <div className="max-w-2xl mx-auto" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6 md:p-10" data-id="element-8">
          <div className="text-center mb-8" data-id="element-9">
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900 mb-2" data-id="element-10">
              ¿Qué tan probable es que te acepten?
            </h2>
            <p className="text-gray-500" data-id="element-11">
              No basta con ver precios. Importa si tu perfil calza.
            </p>
          </div>

          {/* 1. INPUT (SLIDER) */}
          <div className="mb-10" data-id="element-12">
            <div className="flex justify-between items-end mb-4" data-id="element-13">
              <label htmlFor="income-slider" className="block text-sm font-medium text-gray-700" data-id="element-14">
                Simula tu ingreso mensual
              </label>
            </div>

            <div className="relative w-full h-6 flex items-center" data-id="element-15">
              <input id="income-slider" type="range" min="500000" max="5000000" step="50000" value={income} onChange={handleSliderChange} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2" style={{
              background: `linear-gradient(to right, #2563eb 0%, #2563eb ${(income - 500000) / 4500000 * 100}%, #e5e7eb ${(income - 500000) / 4500000 * 100}%, #e5e7eb 100%)`
            }} data-id="element-16" />
            </div>
          </div>

          {/* 2. OUTPUTS (MAIN) */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 mb-8" data-id="element-17">
            <div className="text-center mb-8 pb-8 border-b border-gray-200" data-id="element-18">
              <span className="block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-19">
                Tu Score Rentual
              </span>
              <span className="block text-5xl md:text-6xl font-extrabold text-brand-600 tracking-tight" data-id="element-20">
                {score}
                <span className="text-2xl text-gray-400 font-bold" data-id="element-21">/100</span>
              </span>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-22">
              <div className="text-center md:text-left flex-1" data-id="element-23">
                <span className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1" data-id="element-24">
                  Probabilidad
                </span>
                <span className={`block text-lg font-bold ${compatibilityColor}`} data-id="element-25">
                  {compatibility}
                </span>
              </div>

              <div className="w-full md:w-px h-px md:h-10 bg-gray-200 shrink-0" data-id="element-26" />

              <div className="text-center md:text-right flex-1" data-id="element-27">
                <span className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1" data-id="element-28">
                  Diagnóstico
                </span>
                <span className="block text-sm font-medium text-gray-700" data-id="element-29">
                  {observation}
                </span>
              </div>
            </div>
          </div>

          {/* 3. COMPARISON BOX */}
          <div className="mt-6 bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-30">
            <div className="bg-gray-900 py-4 px-5 text-center" data-id="element-31">
              <p className="text-sm text-white font-medium" data-id="element-32">
                El resultado final se entrega después de validar tu identidad.
              </p>
            </div>
          </div>

          <div className="mt-8 flex justify-center" data-id="element-33">
            <Link to="/score" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-3.5 rounded-full font-medium transition-all text-base" data-id="element-34">
              Ordenar mi arriendo
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}